export const getApiUrl = (origin: string): string => {
  if (window.location.hostname === 'localhost') {
    return origin.replace(/\/$/, '');
  }

  const req = new URL(origin);
  const current = new URL(window.location.origin);

  const sub = req.hostname.split('.')[0];
  const rest = current.hostname.split('.').slice(1);
  req.hostname = [sub, ...rest].join('.');
  return req.toString().replace(/\/$/, '');
};